import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  SendInvitationRequest,
  SendInvitationResponse,
  SentInvitationListResponse,
  SentInvitationSummary,
  VerifyInvitationResponse,
} from '@finxone-platform/shared/sys-config-types';
import { ConfigService } from '../config-service/config-service.service';
import { Observable, map } from 'rxjs';

/**
 * Invitations are owned by org-metadata-service, so every invitation call goes
 * to the metadata API rather than account-service.
 */
@Injectable({
  providedIn: 'root',
})
export class InvitationService {
  private readonly http = inject(HttpClient);
  private readonly configService = inject(ConfigService);

  private baseUrl = '';

  constructor() {
    this.configService.getApi('metadata_service').subscribe((api) => {
      this.baseUrl = api;
    });
  }

  public sendInvitation(payload: SendInvitationRequest): Observable<SendInvitationResponse> {
    return this.http.post<SendInvitationResponse>(`${this.baseUrl}/invitations`, payload);
  }

  public getSentInvitations(): Observable<SentInvitationSummary[]> {
    return this.http
      .get<SentInvitationListResponse>(`${this.baseUrl}/invitations/sent`)
      .pipe(map((response) => response.result));
  }

  public verifyInvitation(token: string): Observable<VerifyInvitationResponse> {
    return this.http.post<VerifyInvitationResponse>(`${this.baseUrl}/invitations/verify`, { token });
  }

  public acceptInvitation(invitationId: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/invitations/${invitationId}/accept`, {});
  }

  public declineInvitation(token: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/invitations/decline`, { token });
  }
}
